import IsAuthenticated from "@/permissions/IsAuthenticated";

export default [
  {
    path: "/profile",
    name: "profile",
    component: () =>
      import(
        /* webpackChunkName: "profile" */ "@/modules/profile/views/Profile.vue"
      ),
    meta: {
      permissions: [IsAuthenticated()]
    }
  }
];
